import XLSX from 'xlsx';

export const excelToJSON = function(file) {

  return new Promise((res, rej) => {
    const reader = new FileReader();

    reader.onload = function(e) {
      const data = e.target.result;
      const workbook = XLSX.read(data, {
        type: 'binary'
      });

      const results = [];

      workbook.SheetNames.forEach(function(sheetName) {
        // Here is your object
        const rowObj = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheetName]);
        console.log('rowObj', rowObj);
        results.push(rowObj);
      });

      res(results);
    };

    reader.onerror = function(ex) {
      rej(ex);
    };

    reader.readAsBinaryString(file);
  });

};



// WEBPACK FOOTER //
// ./src/helpers/parse-excel.js